module.exports = __webpack_public_path__ + "media/images/bg-anihrerseite-2bed450d30d6aca69abe5c071bad95ee.png";